import React, { useState } from "react";
import styled from "styled-components";
import { IAsyncData } from "../../../../../core/models";
import { IApartment } from "../../data/entities";
import Square from "../../../../../components/square";
import { InfoPanel } from "../../../../../components/info_panel/info_panel";
// import { TransparentButton } from "../../../../../components/transparent_button";
import { RepairTypeVideoModal } from "./repair_type_video_modal";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import { IProject } from "../../../project/data/entities";

const InfoText = styled.p`
  margin: 0;
  font-weight: 700;
  color: white;
  font-size: 0.9rem;
  line-height: 1.3;

  a {
    color: black;
    font-weight: 800;

    :hover,
    :focus {
      color: black;
    }
  }
`;

const Bold = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.3;
  white-space: nowrap;
`;

const StyledTitle = styled.p`
  font-weight: 700;
  font-size: 1.1rem;
  text-align: center !important;
  color: white;
  margin: 0;
`;

// const RepairButton = styled(TransparentButton)`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-bottom: 1rem;
//   width: 100%;

//   p {
//     margin: 0;
//     margin-right: 10px;
//   }
// `;

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  apartmentDetailBranch: IAsyncData<IApartment>;
  activeProject: any;
}

export const ApartmentInfoPanel: React.FC<IProps> = ({
  apartmentDetailBranch,
  activeProject,
  ...rest
}: IProps) => {
  const [isRepairTypeVideoModalOpen, setIsRepairTypeVideoModalOpen] =
    useState(false);

  // function openRepairTypeVideoModal() {
  //   setIsRepairTypeVideoModalOpen(true);
  // }

  function closeRepairTypeVideoModal() {
    setIsRepairTypeVideoModalOpen(false);
  }

  return (
    <InfoPanel {...rest}>
      <StyledTitle>
        <>
          {apartmentDetailBranch.data?.roomCount === 0 ? (
            <>Studio tipli mənzil</>
          ) : (
            <>{apartmentDetailBranch.data?.roomCount} otaqlı mənzil</>
          )}
        </>
      </StyledTitle>

      <div
        className="my-2 mx-auto"
        style={{
          width: "140px",
          height: "5px",
          background: "#223A5E",
          borderRadius: "22px",
        }}
      ></div>
      <>
        <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
          <InfoText>Xarici perimetr üzrə sahə</InfoText>
          <Bold>
            <Square square={apartmentDetailBranch.data?.externalSize} />
          </Bold>
        </div>

        <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
          <InfoText>
            Daxili perimetr üzrə sahə <br />
            <span style={{ fontSize: "0.7rem", fontWeight: 500 }}>(Dövlət qeydiyyatı sənədi üzrə)</span>
          </InfoText>
          <Bold>
            <Square square={apartmentDetailBranch.data?.internalSize} />
          </Bold>
        </div>

        <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
          <InfoText>Mənzilin satış qiyməti</InfoText>
          <Bold>{apartmentDetailBranch.data?.price} AZN</Bold>
        </div>

        {activeProject.is_payment_discount_visible === 1 &&
          <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
            <InfoText>
              Əlavə endirimdən sonra <br />
              mənzilin satış qiyməti
            </InfoText>
            <Bold>{apartmentDetailBranch.data?.discountPrice} AZN</Bold>
          </div>
        }
      </>
    </InfoPanel>
  );
};
